import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import SSOLink from "@COMPONENTS/common/ssoLink";
import {PageProps} from "@COMPONENTS/product/pages/detailPackage/common/types";
import * as style from "@COMPONENTS/style/detailpackage/promotionproduct";
import {RecommendationSlide} from "@FRAMEWORK/ui/desktop/slide";
import {SubTitle} from "@FRAMEWORK/ui/desktop/text";
import useRcmnOfSimList from "@QUERIES/chorus/rcmn/useRcmnOfSimList";
import {Noimage} from "@yb/ui/desktop/common/Noimage";
import {format} from "@yb/utils";
import dayjs from "dayjs";
import {useRef} from "react";
import SwiperCore from "swiper";
import {SwiperSlide} from "swiper/react";

const DetailRecommendComponent = (query: PageProps["query"]) => {
	const {evCd} = query;
	/** 추천상품 조회 */
	const rcmnOfSimListFetch = useRcmnOfSimList(evCd, {
		placeholderData: {crmRcmnSearchSimResultList: [], errorCode: "", errorMsg: ""},
	});
	const recommendList = rcmnOfSimListFetch.data.crmRcmnSearchSimResultList || [];
	const swiperRef = useRef<SwiperCore>(null);

	return (
		<>
			{recommendList.length > 0 && (
				<style.Wrap>
					<SubTitle>추천 상품</SubTitle>
					<RecommendationSlide perView={4} spaceBetween={20} ref={swiperRef}>
						{recommendList
							.slice(0, 10) // 최대 10개만 노출
							.map((recommend, index) => {
								const {outStartDt, adtPrice, landing, imageThum1, evNm} = recommend;
								return (
									<SwiperSlide key={index}>
										<SSOLink href={landing} target="_blank">
											<style.SlideImg>
												<Noimage src={imageThum1 || ""} alt="상품 이미지" width="285px" height="195px" />
											</style.SlideImg>
											<style.InfoBox>
												<style.SlideTitle>{evNm}</style.SlideTitle>
												<style.Date>
													<em>출발일</em>
													{dayjs(outStartDt).format("YYYY.MM.DD")}
												</style.Date>
												<style.InfoBottomBlock>
													<style.Price>
														<strong>{format.koKRFormatNumber(adtPrice)}</strong>원
													</style.Price>
												</style.InfoBottomBlock>
											</style.InfoBox>
										</SSOLink>
									</SwiperSlide>
								);
							})}
					</RecommendationSlide>
				</style.Wrap>
			)}
		</>
	);
};

const DetailRecommend = (props: PageProps["query"]) => (
	<ErrorBoundary logMsg="DetailRecommend Error">
		<DetailRecommendComponent {...props} />
	</ErrorBoundary>
);

export default DetailRecommend;
